<script>
import FormInput from '@vvg/forum/js/mixins/formInput'

export default {
	name: "Input",
	mixins: [FormInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'type': {
			type: String,
			default: 'text'
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>

<template>
	<div class="my-3" :class="[groupClasses, { 'has-error': hasError }]">
		<div>
			<input
				v-bind="$attrs"
				:type="type"
				:id="renderedId"
				:name="name"
				:value="modelValue"
				@input="changeModelValue"
				class="field-type-text form-control"
				:placeholder="label"
				:class="{ 'is-invalid': hasError }"
			/>

		</div>
		<small v-if="hasError" class="text-danger d-block mt-1">
			{{ form.errors[name] }}
		</small>
	</div>
</template>